import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';

export default function ContextHelpButton({ section = 'getting-started', title = 'Help', sx = {}, size = 'small' }) {
  const location = useLocation();

  return (
    <Tooltip title={title}>
      <IconButton
        component={RouterLink}
        to="/help"
        state={{ backgroundLocation: location, helpSection: section }}
        size={size}
        aria-label={title}
        sx={{
          width: 34,
          height: 34,
          flexShrink: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
          backdropFilter: 'blur(14px)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          color: '#111827',
          fontWeight: 800,
          '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.95)' },
          ...sx,
        }}
      >
        ?
      </IconButton>
    </Tooltip>
  );
}
